import {connect} from 'react-redux';
import Step16 from './Step16';
import {checkAgentId} from '../../actions/checkAgentId';

const mapStateToProps = ({
                           regType: {regType},
                           stepPayload: {payload}
                         }) => ({
  regType,
  payload
});

export default connect(
  mapStateToProps,
  {checkAgentId}
)(Step16);
